import { Center, Loader } from "@mantine/core";
import { safeApiCall } from "api/common.service";
import { getProductBalanceSummary } from "api/report.service";
import { formatNZD } from "common/utils";
import React, { useEffect, useState } from "react";
import { RptProductBalanceSummary } from "types/model.types";

const StockOnHandPreview: React.FC = () => {
  const [data, setData] = useState<RptProductBalanceSummary | null>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        const result = await safeApiCall(getProductBalanceSummary());
        if (mounted && result) {
          setData(result?.data[0] ?? null);
        }
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  if (loading) {
    return (
      <Center style={{ height: "100vh" }}>
        <Loader size="lg" />
      </Center>
    );
  }

  return (
    <>
      <div className="sub-title">Stock Balance Summary</div>
      <table className="details-table">
        <colgroup>
          <col style={{ width: "40%" }} />
          <col style={{ width: "20%" }} />
          <col style={{ width: "20%" }} />
          <col style={{ width: "20%" }} /> {/* description */}
        </colgroup>
        <thead>
          <th></th>
          <th>Recorded</th>
          <th>Actual</th>
          <th>Difference</th>
        </thead>
        {data && (
          <tbody>
            <tr>
              <td className="bold">Sales MTD</td>
              <td>{formatNZD(data.salesMtd)}</td>
              <td>{formatNZD(0)}</td>
              <td>{formatNZD(data.salesMtd)}</td>
            </tr>
            <tr>
              <td className="bold">Cost MTD</td>
              <td>{formatNZD(data.costMtd)}</td>
              <td>{formatNZD(0)}</td>
              <td>{formatNZD(data.costMtd)}</td>
            </tr>
            <tr>
              <td className="bold">Profit</td>
              <td className="bold">
                {formatNZD(data.salesMtd - data.costMtd)}
              </td>
              <td>{formatNZD(0)}</td>
              <td>{formatNZD(data.salesMtd - data.costMtd)}</td>
            </tr>
            <tr>
              <td className="bold">Quantity MTD</td>
              <td>{formatNZD(data.quanMtd)}</td>
              <td>{formatNZD(0)}</td>
              <td>{formatNZD(data.quanMtd)}</td>
            </tr>
            <tr>
              <td className="bold">Credits</td>
              <td>{formatNZD(0)}</td>
              <td>{formatNZD(0)}</td>
              <td>{formatNZD(0)}</td>
            </tr>
            <tr>
              <td>Stock Value</td>
              <td className="bold" colSpan={3}>
                {formatNZD(data.stockValue)}
              </td>
            </tr>
          </tbody>
        )}
      </table>
    </>
  );
};

export default StockOnHandPreview;
